module.exports = __webpack_public_path__ + "static/img/Ellipse 106.f0d4232.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ellipse 106.png
// module id = dGGf
// module chunks = 1